<template>
  <metainfo>
    <template v-slot:title="{ content }">{{
      content ? `${content} | Digibox` : `Digibox`
    }}</template>
  </metainfo>
  <div class="app-wrapper">
    <div class="columns is-gapless">
      <div v-if="!hideMenu" class="sidebar column app-sidebar">
        <LegoMenu />
      </div>
      <div class="column">
        <div class="container main-container py-4 px-5">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { getCookie } from '@/utils';

import LegoMenu from './components/base/LegoMenu';

export default {
  components: { LegoMenu },
  setup() {
    const route = useRoute();
    const store = useStore();

    const hideMenuFor = [
      'Login',
      'LoginUnknown',
      'ForgotPassword',
      'NewPassword',
    ];

    const hideMenu = computed(() => hideMenuFor.includes(route.name));
    const authUser = computed(() => store.getters.authUser);
    const digiboxes = computed(() => store.getters.digiboxes);

    onMounted(async () => {
      const tokenId = getCookie('Token');
      if (tokenId) {
        store.dispatch('checkLogin');
      }
    });

    return {
      hideMenu,
      authUser,
      digiboxes,
      store,
    };
  },
};
</script>
